<!--
 * @Author: zhaoliang
 * @Date: 2023-12-05 16:48:48
 * @LastEditTime: 2026-01-23 11:51:03
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/components/BaseUi/ProductDetailsCards/newIndex.vue
 *
-->
<template>
  <div v-if="productData">
    <!-- <pdf-dialog
      :isShowPDFTitle="false"
      :showPdfModal="showPdfModal"
      :pdfUrl="pdfUrl"
      @pdfShow="handleView"
    ></pdf-dialog> -->
    <PDFModal v-model:open="showPdfModal" :pdfUrl="pdfUrl" />
    <section class="card-wrapper" v-show="!showPdfModal">
      <div class="card-top">
        <!-- <div class="card-title" @click="goBack">
          <span class="airport-name">{{ productData.airportName }} {{ productData.iataCode }}</span>
        </div> -->
        <h2 class="card-title" @click="goBack">{{ productData.airportName }} {{ productData.iataCode }}</h2>
        <div class="card-operate">
          <div
            v-if="loungeInfo || diningInfo"
            class="favor-wrapper"
            @click="toggleFavor"
            role="favor"
          >
            <span :class="[{ 'full-heart': clickFavor }, 'heart']"></span>
          </div>
          <div
            v-if="loungeInfo"
            class="help-wrapper"
            @click="showHelpFaq = !showHelpFaq"
            role="help"
          >
            <span class="icon-help" :class="{ 'icon-help-close': showHelpFaq }"></span>
          </div>
          <template v-if="clickNeedShow">
            <info-popup class="popup-box" :text="favorDesc" :showFavor="clickFavor" />
            <info-popup class="popup-box" :text="favorDesc" :showFavor="!clickFavor" />
          </template>
          <template v-if="showHelpFaq">
            <div class="help-box">
              <p><span class="icon-help-reverse"></span> {{ $t('tips-title') }}</p>
              <p class="subtitle">{{ $t('lounge-help-q-1') }}</p>
              <p>{{ $t('lounge-help-a-1') }}</p>
              <p class="subtitle">{{ $t('lounge-help-q-2') }}</p>
              <p>{{ $t('lounge-help-a-2') }}</p>
              <p>{{ $t('lounge-help-desc-1') }}</p>
            </div>
          </template>
        </div>
      </div>
      <div class="card-bottom">
        <div class="card-left">
          <div class="carousel-wrapper">
            <div class="home-page-carousel">
              <!-- <div
                class="no-access-credit-card"
                v-if="
                  loungeInfo &&
                  productData.allowWriteOff !== undefined &&
                  (!productData.allowWriteOff || productData.allowWriteOff === 'false')
                "
              >
                {{ $t('no-access-via-credit-card') }}
              </div> -->
              <Swiper
                class="swiper"
                :modules="modules"
                :space-between="10"
                :loop="!retailInfo && productData.imagesList && productData.imagesList.length > 1"
                :autoplay="{ delay: 10000, disableOnInteraction: false }"
                :pagination="{
                  el: '.swiper-pagination',
                  clickable: true,
                  bulletClass: 'swiper-pagination-bullet-custom',
                  bulletActiveClass: 'swiper-pagination-bullet-active-custom',
                }"
                :navigation="{
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                  addIcons: false,
                }"
                @slideChangeTransitionEnd="onSlideChangeTransitionEnd"
                v-show="retailInfo || productData.imagesList"
              >
                <template v-if="retailInfo">
                  <SwiperSlide class="swiper-slide">
                    <img :src="productData.imgUrl" alt="banners" />
                  </SwiperSlide>
                </template>
                <template v-else>
                  <SwiperSlide
                    class="swiper-slide"
                    v-for="(item, index) in productData.imagesList"
                    :key="index"
                  >
                    <img :src="item.url" alt="banners" />
                  </SwiperSlide>
                  <div v-show="productData.imagesList.length > 1" class="swiper-pagination"></div>
                  <div class="swiper-button-prev" style="display: none"></div>
                  <div v-show="productData.imagesList.length > 1" class="swiper-button-next"></div>
                </template>
              </Swiper>
            </div>
          </div>
          <h1 class="product-name">{{ productData.name }}</h1>
          <div class="product-info">
            <img src="~img/icon-location.svg" alt="locations" />
            <!-- lounge and dining -->
            <div v-if="loungeInfo || diningInfo" class="product-info-desc">
              {{ productData.airportName }}{{ productData.iataCode && ` ${productData.iataCode}`
              }}{{ productData.terminal && `, ${productData.terminal}`
              }}{{ productData.type && `, ${productData.type}`
              }}{{ productData.inspection && `, ${productData.inspection}`
              }}{{ productData.region && `, ${productData.region}` }}
            </div>
            <!-- retail -->
            <div v-else-if="retailInfo" class="product-info-desc">
              <!-- multiple location -->
              <div v-if="typeData.code.split(',').length > 1">
                <span>{{ $t('location-') }}: {{ productData.terminal }}</span>
                <br />
                <span class="view-location" @click="goToFilter">{{
                  $t('view-all-locations')
                }}</span>
              </div>
              <!-- single location -->
              <div v-else>
                {{
                  [
                    retailInfo.retail.terminal,
                    retailInfo.retail.travelType,
                    retailInfo.retail.region,
                    retailInfo.retail.inspection,
                    retailInfo.retail.boardingGate
                      ? `${$t('near-boarding-gate')}: ${retailInfo.retail.boardingGate}`
                      : retailInfo.retail.boardingGate,
                  ]
                    .filter(i => i)
                    .join(', ')
                }}
              </div>
            </div>
          </div>
          <div
            class="product-info mobile-opening-times opening-times-lounge"
            v-if="loungeInfo && productData.businessHoursVO.open !== null"
          >
            <img src="~img/icon-time-solid.svg" alt="times" />
            <div class="opening-times-desc">
              <div class="times">
                <span v-if="productData.businessHoursVO.type === 'all-day'">
                  <span class="opening-now">{{ $t('open-now') }}</span> -
                  {{ productData.businessHoursVO.nextStatusAndTime }}
                </span>
                <span v-if="productData.businessHoursVO.type === 'early-late-flight'">
                  {{ $t('early-late-flight') }}
                  <br />
                  {{ productData.businessHoursVO.label }}
                </span>
                <span v-if="productData.businessHoursVO.type === 'time'">
                  <span class="opening-now">{{
                    productData.businessHoursVO.open ? $t('open-now') : $t('closed-now')
                  }}</span>
                  - {{ productData.businessHoursVO.nextStatusAndTime }}
                  <br />
                  {{ productData.businessHoursVO.label }}
                </span>
                <span v-if="productData.businessHoursVO.type === 'special'">
                  {{ productData.businessHoursVO.label }}
                </span>
                <span v-if="productData.businessHoursVO.type === 'week'">
                  <span class="opening-now"
                    >{{ productData.businessHoursVO.open ? $t('open-now') : $t('closed-now') }}
                  </span>
                  - {{ productData.businessHoursVO.nextStatusAndTime }}
                  <div class="week-time-box">
                    <div class="week-time" v-for="item in productData.businessHoursVO.weekDays">
                      <span class="label">{{ item.dayOfWeekLabel }}:</span>
                      <span class="time">{{ item.businessHoursStr }}</span>
                    </div>
                  </div>
                </span>
                <span v-if="productData.businessHoursVO.type === 'date-time'">
                  <div v-for="item in productData.businessHoursVO.dateTimes">
                    <span class="opening-now">{{ item.dateRange }}</span>
                    <br />
                    {{ item.timeRange }}
                  </div>
                </span>
                <span
                  v-if="
                    productData.businessHoursVO.type === 'newTimeRule' &&
                    productData.businessHoursVO.newFormats.length
                  "
                >
                  <span class="opening-now"
                    >{{ productData.businessHoursVO.open ? $t('open-now') : $t('closed-now') }}
                  </span>
                  - {{ productData.businessHoursVO.nextStatusAndTime }}
                  <div class="week-time-box">
                    <div v-if="showDateRanger" class="date-ranger-select">
                      <div
                        v-for="(item, index) in productData.businessHoursVO.newFormats"
                        :key="index"
                        class="date-select"
                        @click="
                          () => {
                            currentDateRangeIndex = index;
                            showDateRanger = !showDateRanger;
                          }
                        "
                      >
                        <span>{{ item.dateRange }}</span>
                        <span v-if="index === 0" class="arrow"></span>
                      </div>
                    </div>
                    <div class="date-select" @click="() => (showDateRanger = !showDateRanger)">
                      <span>{{
                        productData.businessHoursVO.newFormats[currentDateRangeIndex].dateRange
                      }}</span>
                      <span class="arrow"></span>
                    </div>
                    <div
                      class="week-time date-select-week-time"
                      v-for="(item, index) in productData.businessHoursVO.newFormats[
                        currentDateRangeIndex
                      ].weekVOS"
                      :key="index"
                    >
                      <span class="label">{{ item.dayOfWeekLabel }}:</span>
                      <span class="time">{{ item.businessHoursStr }}</span>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div
            class="product-info mobile-opening-times"
            v-else-if="
              (!loungeInfo && productData.businessHours) ||
              (retailInfo && retailInfo.retail && retailInfo.retail.businessHours)
            "
          >
            <img src="~img/icon-time-solid.svg" alt="times" />
            <div
              class="product-info-desc"
              v-html="productData.businessHours || retailInfo.retail.businessHours"
            ></div>
          </div>
          <!-- <div class="product-boardinggate" v-if="productData.boardinggate">
            <br />
            <div class="desc">{{ $t('near-boarding-gate') }}: {{ productData.boardinggate }}</div>
          </div> -->
          <!-- 与下面 card-right 代码一模一样,只是为了兼容移动端排版, 后续可以改成mixin -->
          <div class="card-right mobile-card-box">
            <div class="right-wrapper">
              <!-- lounge -->
              <template v-if="loungeInfo">
                <div v-if="!isLogin" class="lounge-card-box">
                  <div class="lounge-card-title">{{ $t('visit-lounge') }}</div>
                  <div class="lounge-card-desc">{{ $t('ask-login') }}</div>
                  <button class="lounge-card-btn" @click="goToMembership">
                    {{ $t('login-to-continue') }}
                  </button>
                </div>
                <div v-else class="lounge-card-box-login">
                  <div class="lounge-card-title">{{ $t('visit-lounge') }}</div>
                  <!-- <div class="lounge-card-desc">Prices displayed as $USD per person</div> -->
                  <div class="lounge-card-desc">{{ productData.mtpPriceNote }}</div>
                  <div
                    class="access-box"
                    @click="goToNext(item.type)"
                    v-for="item in productData.rulesOfUse"
                  >
                    <div class="access-payment" v-for="sub in item.rows">
                      <div class="access-payment-title" v-if="sub.title">
                        <img v-if="sub.logo" :src="sub.logo" alt="" />
                        <span v-if="sub.title">{{ sub.title }}</span>
                        <label v-if="sub.label">{{ sub.label }}</label>
                      </div>
                      <div class="access-payment-desc" v-if="sub.description">
                        {{ sub.description }}
                      </div>
                      <div class="access-payment-divide-line"></div>
                    </div>
                    <button class="lounge-card-btn-login" v-if="item.type === 'pre-book'">
                      {{ $t('prebook-title') }}
                    </button>
                    <button class="lounge-card-btn-login" v-if="item.type === 'walk-in'">
                      <img src="~img/icon-qr.svg" alt="" /> {{ $t('walkin') }}
                    </button>
                  </div>
                  <div v-if="productData.mtpNote" class="lounge-card-note">
                    *{{ productData.mtpNote }}
                  </div>
                  <!-- <div
                    class="access-box"
                    @click="goToPrebook"
                    v-if="productData.bookable === 'true'"
                  >
                    <div class="access-payment">
                      <div class="access-payment-title">{{ $t('prebook-title') }}</div>
                      <div class="access-payment-desc">{{ $t('book-in-advance') }}</div>
                      <div class="access-payment-divide-line"></div>
                      <template v-for="(item, index) in prebookingPrice">
                        <div v-if="index !== 0" class="access-payment-detail-divide">
                          &nbsp;{{ $t('or') }}&nbsp;
                        </div>
                        <div class="access-payment-detail">
                          <div class="access-payment-detail-way">
                            <img
                              v-if="item.type === '1'"
                              src="~img/icon-entitlement-solid.svg"
                              alt="access-payment-icon"
                            />
                            <img
                              v-if="item.type === '2'"
                              src="~img/icon-card-outline.svg"
                              alt="access-payment-icon"
                            />
                            <span>{{ item.label }}</span>
                          </div>
                          <div class="access-payment-detail-count">{{ item.value }}</div>
                        </div>
                      </template>
                    </div>
                    <button class="lounge-card-btn-login">{{ $t('prebook-title') }}</button>
                  </div>
                  <div class="access-box" @click="goToMembership">
                    <div class="access-payment">
                      <div class="access-payment-title">{{ $t('walkin') }}</div>
                      <div class="access-payment-desc">{{ $t('get-access-lounge') }}</div>
                      <div class="access-payment-divide-line"></div>
                      <template v-for="(item, index) in walkinPrice">
                        <div v-if="index !== 0" class="access-payment-detail-divide">
                          &nbsp;{{ $t('or') }}&nbsp;
                        </div>
                        <div class="access-payment-detail">
                          <div class="access-payment-detail-way">
                            <img
                              v-if="item.type === '3'"
                              src="~img/icon-entitlement-solid.svg"
                              alt="access-payment-icon"
                            />
                            <img
                              v-if="item.type === '4'"
                              src="~img/icon-card-outline.svg"
                              alt="access-payment-icon"
                            />
                            <span>{{ item.label }}</span>
                          </div>
                          <div class="access-payment-detail-count">{{ item.value }}</div>
                        </div>
                      </template>
                    </div>
                    <button class="lounge-card-btn-login">{{ $t('walkin') }}</button>
                  </div> -->
                </div>
              </template>
              <!-- dining -->
              <template v-if="diningInfo">
                <div
                  class="dining-card-suspended"
                  v-if="isLogin && !productData.redeemAble && productData.reminder"
                >
                  <img src="~img/icon-warning.svg" alt="" />
                  <div class="dpid-suspended-box">
                    <div class="dpid-suspended-title">{{ productData.reminder.title }}</div>
                    <div class="dpid-suspended-desc">{{ productData.reminder.content }}</div>
                  </div>
                </div>
                <div class="dining-available-offers">{{ $t('available-offers') }}</div>
                <div v-if="!isLogin" class="lounge-card-box">
                  <div class="lounge-card-title">{{ $t('redeem-offer') }}</div>
                  <div class="lounge-card-desc">{{ $t('offer-need-login') }}</div>
                  <button class="lounge-card-btn" @click="goToMembership">
                    {{ $t('login') }}
                  </button>
                </div>
                <div v-else class="lounge-card-box-login">
                  <div class="dining-offer-box" v-for="item in productData.setMealList">
                    <div class="lounge-card-title">
                      <!-- {{ $t('dining-setmeal') }} -->
                      {{ item.name }}
                    </div>
                    <div class="lounge-card-desc" v-for="descItem in item.description">
                      {{ descItem }}
                    </div>
                    <div class="setmeal-card-desc" v-for="groupItem in item.groupMap">
                      <div class="setmeal-card-group">{{ groupItem.group }}</div>
                      <ul>
                        <li v-for="option in groupItem.options">{{ option }}</li>
                      </ul>
                    </div>
                    <button
                      class="lounge-card-btn"
                      :class="{ disabled: !productData.redeemAble }"
                      @click="handleView({ setMeal: true, setMealId: item.code })"
                    >
                      {{ $t('redeem-setmeal') }}
                    </button>
                  </div>
                  <div class="dining-offer-box" v-for="item in productData.productsDiscountList">
                    <div class="lounge-card-title" v-if="item.modeType === 'MPV'">
                      {{ $t('dining-mpv', [item.discount]) }}
                    </div>
                    <div class="lounge-card-title" v-else-if="item.modeType === 'discount'">
                      {{ $t('dining-discount') }}
                    </div>
                    <div class="lounge-card-title" v-else-if="item.modeType === 'promo'">
                      {{ $t('dining-promo') }}
                    </div>
                    <div class="lounge-card-title" v-else-if="item.modeType === 'setmeal'">
                      {{ $t('dining-setmeal') }}
                    </div>
                    <div class="lounge-card-desc" v-if="item.modeType === 'MPV'">
                      {{ $t('dining-mpv-descrition') }}
                    </div>
                    <div class="lounge-card-desc" v-else>{{ item.note }}</div>
                    <button
                      class="lounge-card-btn"
                      :class="{ disabled: !productData.redeemAble }"
                      v-if="item.modeType === 'MPV'"
                      @click="handleView({ type: item.type, modeType: item.modeType })"
                    >
                      {{ $t('redeem-mpv', [item.discount]) }}
                    </button>
                    <button
                      class="lounge-card-btn"
                      :class="{ disabled: !productData.redeemAble }"
                      v-else-if="item.modeType === 'discount'"
                      @click="handleView({ type: item.type, modeType: item.modeType })"
                    >
                      {{ $t('redeem-discount') }}
                    </button>
                    <button
                      class="lounge-card-btn"
                      :class="{ disabled: !productData.redeemAble }"
                      v-else-if="item.modeType === 'promo'"
                      @click="handleView({ type: item.type, modeType: item.modeType })"
                    >
                      {{ $t('redeem-promo') }}
                    </button>
                  </div>
                </div>
              </template>
              <!-- retail -->
              <template v-if="retailInfo">
                <div v-if="!isLogin" class="lounge-card-box">
                  <div class="lounge-card-title">{{ $t('redeem-offer') }}</div>
                  <div class="lounge-card-desc">{{ $t('offer-need-login') }}</div>
                  <button class="lounge-card-btn" @click="goToMembership">
                    {{ $t('login') }}
                  </button>
                </div>
                <div v-else class="lounge-card-box">
                  <div class="lounge-card-title">{{ $t('redeem-offer') }}</div>
                  <div class="lounge-card-desc">{{ $t('offer-click-btn') }}</div>
                  <button class="lounge-card-btn" @click="goToFilter">
                    {{ $t('redeem-offer') }}
                  </button>
                </div>
              </template>
              <!-- opening-times -->
              <div
                class="opening-times"
                v-if="
                  productData.businessHours ||
                  (retailInfo && retailInfo.retail && retailInfo.retail.businessHours)
                "
              >
                <img src="~img/icon-time-solid.svg" alt="times" />
                <div class="opening-times-desc">
                  <div class="title">{{ $t('opening-times') }}</div>
                  <div class="times">
                    {{ productData.businessHours || retailInfo.retail.businessHours }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="product-offer-details" v-if="productData.discount">
            <div class="title">{{ $t('offer-details') }}</div>
            <div class="desc">
              {{ productData.discount }}
              <span class="retail-multiple-locations" v-if="typeData.code.split(',').length > 1">{{
                $t('redeem-offer-at-all-shops-at-this-airport')
              }}</span>
            </div>
          </div>
          <div class="product-facilities show-in-mobile" v-if="facilities && facilities.length">
            <div class="title" @click="isFacilitiesOpen = !isFacilitiesOpen">
              <div>
                <span>{{ $t('facilities') }}</span>
                <span class="mobile-facilities"> ({{ facilities.length }})</span>
              </div>
              <img
                :class="['facilities-arrow', { 'arrow-up': isFacilitiesOpen }]"
                src="~img/faqArrowDown.svg"
                alt=""
              />
            </div>
            <div class="facilities">
              <div
                :class="['fac-item', { 'facilities-open': isFacilitiesOpen }]"
                v-for="(item, index) in facilities"
                :key="index"
              >
                <!-- 在pc端模式下, 展示全部 -->
                <img
                  :key="index + 'pc'"
                  :src="getFacilitiesPic[index]"
                  alt="facilities icon"
                  class="fac-img"
                />
                <!-- h5模式下, 在未展开的情况下, 如果facilities个数小于等于5个,则全部展示,否则展示5个+1个省略号, -->
                <img
                  :key="index + 'mobile'"
                  :src="getFacilitiesPic[index]"
                  alt="facilities icon"
                  class="fac-img mobile-facilities"
                  v-if="isFacilitiesOpen || index < 5"
                />
                <img
                  :key="index + 'ellipsis'"
                  src="~img/icon-ellipsis.svg"
                  alt="facilities icon"
                  class="fac-img mobile-facilities"
                  v-else
                />
                <div :class="['fac-desc', { 'facilities-open': isFacilitiesOpen }]">
                  {{ getFacilitiesCategory[index].toString() }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="product-locations"
            v-if="
              productData.locationGuide ||
              productData.location ||
              productData.boardinggate ||
              (retailInfo && retailInfo.retail && retailInfo.retail.locationGuide)
            "
          >
            <div class="title">{{ $t('directions-') }}</div>
            <div class="desc">
              <span
                v-if="productData.locationGuide || productData.location || productData.boardinggate"
              >
                {{ productData.locationGuide || productData.location || '' }}
                {{
                  productData.boardinggate
                    ? `${$t('near-boarding-gate')}: ${productData.boardinggate}`
                    : ''
                }}
              </span>
              <span v-else-if="retailInfo && retailInfo.retail && retailInfo.retail.locationGuide">
                {{ retailInfo.retail.locationGuide }}
              </span>
            </div>
          </div>
          <div
            class="product-description"
            v-if="productData.publicity || productData.overview || productData.rule"
          >
            <div class="title">{{ $t('description') }}</div>
            <div class="desc">
              <template v-if="retailInfo && productData.publicity">
                {{ productData.publicity }}
              </template>
              <template v-else-if="productData.overview">
                {{ productData.overview }}
              </template>
              <template v-else-if="productData.rule">
                {{ productData.rule }}
              </template>
            </div>
          </div>
          <div class="product-facilities show-in-desktop" v-if="facilities && facilities.length">
            <div class="title" @click="isFacilitiesOpen = !isFacilitiesOpen">
              <div>
                <span>{{ $t('facilities') }}</span>
                <span class="mobile-facilities"> ({{ facilities.length }})</span>
              </div>
              <img
                :class="['facilities-arrow', { 'arrow-up': isFacilitiesOpen }]"
                src="~img/faqArrowDown.svg"
                alt=""
              />
            </div>
            <div class="facilities">
              <div
                :class="['fac-item', { 'facilities-open': isFacilitiesOpen }]"
                v-for="(item, index) in facilities"
                :key="index"
              >
                <!-- 在pc端模式下, 展示全部 -->
                <img
                  :key="index + 'pc'"
                  :src="getFacilitiesPic[index]"
                  alt="facilities icon"
                  class="fac-img"
                />
                <!-- h5模式下, 在未展开的情况下, 如果facilities个数小于等于5个,则全部展示,否则展示5个+1个省略号, -->
                <img
                  :key="index + 'mobile'"
                  :src="getFacilitiesPic[index]"
                  alt="facilities icon"
                  class="fac-img mobile-facilities"
                  v-if="isFacilitiesOpen || index < 5"
                />
                <img
                  :key="index + 'ellipsis'"
                  src="~img/icon-ellipsis.svg"
                  alt="facilities icon"
                  class="fac-img mobile-facilities"
                  v-else
                />
                <div :class="['fac-desc', { 'facilities-open': isFacilitiesOpen }]">
                  {{ getFacilitiesCategory[index].toString() }}
                </div>
              </div>
            </div>
          </div>
          <div class="product-bottom-space"></div>
        </div>
        <div class="card-right">
          <div class="right-wrapper">
            <!-- lounge -->
            <template v-if="loungeInfo">
              <div v-if="!isLogin" class="lounge-card-box">
                <div class="lounge-card-title">{{ $t('visit-lounge') }}</div>
                <div class="lounge-card-desc">{{ $t('ask-login') }}</div>
                <button class="lounge-card-btn" @click="goToMembership">
                  {{ $t('login-to-continue') }}
                </button>
              </div>
              <div v-else class="lounge-card-box-login">
                <div class="lounge-card-title">{{ $t('visit-lounge') }}</div>
                <div class="lounge-card-desc">{{ productData.mtpPriceNote }}</div>
                <div
                  class="access-box"
                  @click="goToNext(item.type)"
                  v-for="item in productData.rulesOfUse"
                >
                  <div class="access-payment" v-for="sub in item.rows">
                    <div class="access-payment-title" v-if="sub.title">
                      <img v-if="sub.logo" :src="sub.logo" alt="" />
                      <span v-if="sub.title">{{ sub.title }}</span>
                      <label v-if="sub.label">{{ sub.label }}</label>
                    </div>
                    <div class="access-payment-desc" v-if="sub.description">
                      {{ sub.description }}
                    </div>
                    <div class="access-payment-divide-line"></div>
                  </div>
                  <button class="lounge-card-btn-login" v-if="item.type === 'pre-book'">
                    {{ $t('prebook-title') }}
                  </button>
                  <button class="lounge-card-btn-login" v-if="item.type === 'walk-in'">
                    <img src="~img/icon-qr.svg" alt="" />{{ $t('walkin') }}
                  </button>
                </div>
                <div v-if="productData.mtpNote" class="lounge-card-note">
                  *{{ productData.mtpNote }}
                </div>
                <div
                  class="no-access"
                  v-if="
                    productData.allowWriteOff !== undefined &&
                    (!productData.allowWriteOff || productData.allowWriteOff === 'false')
                  "
                >
                  {{ $t('no-access-via-credit-card') }}
                </div>
                <!-- <div class="access-box" @click="goToPrebook" v-if="productData.bookable === 'true'">
                  <div class="access-payment">
                    <div class="access-payment-title">{{ $t('prebook-title') }}</div>
                    <div class="access-payment-desc">{{ $t('book-in-advance') }}</div>
                    <div class="access-payment-divide-line"></div>
                    <template v-for="(item, index) in prebookingPrice">
                      <div v-if="index !== 0" class="access-payment-detail-divide">
                        &nbsp;{{ $t('or') }}&nbsp;
                      </div>
                      <div class="access-payment-detail">
                        <div class="access-payment-detail-way">
                          <img
                            v-if="item.type === '1'"
                            src="~img/icon-entitlement-solid.svg"
                            alt="access-payment-icon"
                          />
                          <img
                            v-if="item.type === '2'"
                            src="~img/icon-card-outline.svg"
                            alt="access-payment-icon"
                          />
                          <span>{{ item.label }}</span>
                        </div>
                        <div class="access-payment-detail-count">{{ item.value }}</div>
                      </div>
                    </template>
                  </div>
                  <button class="lounge-card-btn-login">{{ $t('prebook-title') }}</button>
                </div>
                <div class="access-box" @click="goToMembership">
                  <div class="access-payment">
                    <div class="access-payment-title">{{ $t('walkin') }}</div>
                    <div class="access-payment-desc">{{ $t('get-access-lounge') }}</div>
                    <div class="access-payment-divide-line"></div>
                    <template v-for="(item, index) in walkinPrice">
                      <div v-if="index !== 0" class="access-payment-detail-divide">
                        &nbsp;{{ $t('or') }}&nbsp;
                      </div>
                      <div class="access-payment-detail">
                        <div class="access-payment-detail-way">
                          <img
                            v-if="item.type === '3'"
                            src="~img/icon-entitlement-solid.svg"
                            alt="access-payment-icon"
                          />
                          <img
                            v-if="item.type === '4'"
                            src="~img/icon-card-outline.svg"
                            alt="access-payment-icon"
                          />
                          <span>{{ item.label }}</span>
                        </div>
                        <div class="access-payment-detail-count">{{ item.value }}</div>
                      </div>
                    </template>
                  </div>
                  <button class="lounge-card-btn-login">{{ $t('walkin') }}</button>
                </div> -->
              </div>
            </template>
            <!-- dining -->
            <template v-if="diningInfo">
              <div
                class="dining-card-suspended"
                v-if="isLogin && !productData.redeemAble && productData.reminder"
              >
                <img src="~img/icon-warning.svg" alt="" />
                <div class="dpid-suspended-box">
                  <div class="dpid-suspended-title">{{ productData.reminder.title }}</div>
                  <div class="dpid-suspended-desc">{{ productData.reminder.content }}</div>
                </div>
              </div>
              <div class="dining-available-offers">{{ $t('available-offers') }}</div>
              <div v-if="!isLogin" class="lounge-card-box">
                <div class="lounge-card-title">{{ $t('redeem-offer') }}</div>
                <div class="lounge-card-desc">{{ $t('offer-need-login') }}</div>
                <button class="lounge-card-btn" @click="goToMembership">
                  {{ $t('login') }}
                </button>
              </div>
              <div v-else class="lounge-card-box-login">
                <div class="dining-offer-box" v-for="item in productData.setMealList">
                  <div class="lounge-card-title">
                    <!-- {{ $t('dining-setmeal') }} -->
                    {{ item.name }}
                  </div>
                  <div class="lounge-card-desc" v-for="descItem in item.description">
                    {{ descItem }}
                  </div>
                  <div
                    class="setmeal-card-desc"
                    v-if="item.groupMap.length"
                    v-for="groupItem in item.groupMap"
                  >
                    <div class="setmeal-card-group">{{ groupItem.group }}</div>
                    <ul>
                      <li v-for="option in groupItem.options">{{ option }}</li>
                    </ul>
                  </div>
                  <button
                    class="lounge-card-btn"
                    :class="{ disabled: !productData.redeemAble }"
                    @click="handleView({ setMeal: true, setMealId: item.code })"
                  >
                    {{ $t('redeem-setmeal') }}
                  </button>
                </div>
                <div class="dining-offer-box" v-for="item in productData.productsDiscountList">
                  <div class="lounge-card-title" v-if="item.modeType === 'MPV'">
                    {{ $t('dining-mpv', [item.discount]) }}
                  </div>
                  <div class="lounge-card-title" v-else-if="item.modeType === 'discount'">
                    {{ $t('dining-discount') }}
                  </div>
                  <div class="lounge-card-title" v-else-if="item.modeType === 'promo'">
                    {{ $t('dining-promo') }}
                  </div>
                  <div class="lounge-card-title" v-else-if="item.modeType === 'setmeal'">
                    {{ $t('dining-setmeal') }}
                  </div>
                  <div class="lounge-card-desc" v-if="item.modeType === 'MPV'">
                    {{ $t('dining-mpv-descrition') }}
                  </div>
                  <div class="lounge-card-desc" v-else>{{ item.note }}</div>
                  <button
                    class="lounge-card-btn"
                    :class="{ disabled: !productData.redeemAble }"
                    v-if="item.modeType === 'MPV'"
                    @click="handleView({ type: item.type, modeType: item.modeType })"
                  >
                    {{ $t('redeem-mpv', [item.discount]) }}
                  </button>
                  <button
                    class="lounge-card-btn"
                    :class="{ disabled: !productData.redeemAble }"
                    v-else-if="item.modeType === 'discount'"
                    @click="handleView({ type: item.type, modeType: item.modeType })"
                  >
                    {{ $t('redeem-discount') }}
                  </button>
                  <button
                    class="lounge-card-btn"
                    :class="{ disabled: !productData.redeemAble }"
                    v-else-if="item.modeType === 'promo'"
                    @click="handleView({ type: item.type, modeType: item.modeType })"
                  >
                    {{ $t('redeem-promo') }}
                  </button>
                </div>
              </div>
            </template>
            <!-- retail -->
            <template v-if="retailInfo">
              <div v-if="!isLogin" class="lounge-card-box">
                <div class="lounge-card-title">{{ $t('redeem-offer') }}</div>
                <div class="lounge-card-desc">{{ $t('offer-need-login') }}</div>
                <button class="lounge-card-btn" @click="goToMembership">
                  {{ $t('login') }}
                </button>
              </div>
              <div v-else class="lounge-card-box">
                <div class="lounge-card-title">{{ $t('redeem-offer') }}</div>
                <div class="lounge-card-desc">{{ $t('offer-click-btn') }}</div>
                <button class="lounge-card-btn" @click="goToFilter">
                  {{ $t('redeem-offer') }}
                </button>
              </div>
            </template>
            <!-- opening-times -->
            <div
              class="opening-times-lounge"
              v-if="
                loungeInfo && productData.businessHoursVO.open !== null
                // !(
                //   productData.businessHoursVO.type === 'date-time' &&
                //   productData.businessHoursVO.dateTimes.length === 0
                // ) &&
                // !(
                //   productData.businessHoursVO.type === 'newTimeRule' &&
                //   productData.businessHoursVO.newFormats.length === 0
                // )
              "
            >
              <div
                class="title"
                v-if="
                  productData.businessHoursVO.type !== 'week' &&
                  productData.businessHoursVO.type !== 'newTimeRule'
                "
              >
                {{ $t('opening-times') }}
              </div>
              <div class="opening-times-desc">
                <img src="~img/icon-time-solid.svg" alt="times" />
                <div class="times">
                  <span v-if="productData.businessHoursVO.type === 'all-day'">
                    <span class="opening-now">{{ $t('open-now') }}</span> -
                    {{ productData.businessHoursVO.nextStatusAndTime }}
                  </span>
                  <span v-if="productData.businessHoursVO.type === 'early-late-flight'">
                    {{ $t('early-late-flight') }}
                    <br />
                    {{ productData.businessHoursVO.label }}
                  </span>
                  <span v-if="productData.businessHoursVO.type === 'time'">
                    <span class="opening-now"
                      >{{ productData.businessHoursVO.open ? $t('open-now') : $t('closed-now') }}
                    </span>
                    - {{ productData.businessHoursVO.nextStatusAndTime }}
                    <br />
                    {{ productData.businessHoursVO.label }}
                  </span>
                  <span v-if="productData.businessHoursVO.type === 'special'">
                    {{ productData.businessHoursVO.label }}
                  </span>
                  <span v-if="productData.businessHoursVO.type === 'week'">
                    <span class="opening-now"
                      >{{ productData.businessHoursVO.open ? $t('open-now') : $t('closed-now') }}
                    </span>
                    - {{ productData.businessHoursVO.nextStatusAndTime }}
                    <div class="week-time-box">
                      <div class="week-time" v-for="item in productData.businessHoursVO.weekDays">
                        <span class="label">{{ item.dayOfWeekLabel }}:</span>
                        <span class="time">{{ item.businessHoursStr }}</span>
                      </div>
                    </div>
                  </span>
                  <span v-if="productData.businessHoursVO.type === 'date-time'">
                    <div v-for="item in productData.businessHoursVO.dateTimes">
                      <span class="opening-now">{{ item.dateRange }}</span>
                      <br />
                      {{ item.timeRange }}
                    </div>
                  </span>
                  <span
                    v-if="
                      productData.businessHoursVO.type === 'newTimeRule' &&
                      productData.businessHoursVO.newFormats.length
                    "
                  >
                    <span class="opening-now"
                      >{{ productData.businessHoursVO.open ? $t('open-now') : $t('closed-now') }}
                    </span>
                    - {{ productData.businessHoursVO.nextStatusAndTime }}
                    <div class="week-time-box">
                      <div v-if="showDateRanger" class="date-ranger-select">
                        <div
                          v-for="(item, index) in productData.businessHoursVO.newFormats"
                          :key="index"
                          class="date-select"
                          @click="
                            () => {
                              currentDateRangeIndex = index;
                              showDateRanger = !showDateRanger;
                            }
                          "
                        >
                          <span>{{ item.dateRange }}</span>
                          <span v-if="index === 0" class="arrow"></span>
                        </div>
                      </div>
                      <div class="date-select" @click="() => (showDateRanger = !showDateRanger)">
                        <span>{{
                          productData.businessHoursVO.newFormats[currentDateRangeIndex].dateRange
                        }}</span>
                        <span class="arrow"></span>
                      </div>
                      <div
                        class="week-time date-select-week-time"
                        v-for="(item, index) in productData.businessHoursVO.newFormats[
                          currentDateRangeIndex
                        ].weekVOS"
                        :key="index"
                      >
                        <span class="label">{{ item.dayOfWeekLabel }}:</span>
                        <span class="time">{{ item.businessHoursStr }}</span>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div
              class="opening-times-lounge"
              v-else-if="
                (!loungeInfo && productData.businessHours) ||
                (retailInfo && retailInfo.retail && retailInfo.retail.businessHours)
              "
            >
              <div class="title">{{ $t('opening-times') }}</div>
              <div class="opening-times-desc">
                <img src="~img/icon-time-solid.svg" alt="times" />
                <div
                  class="times"
                  v-html="productData.businessHours || retailInfo.retail.businessHours"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div v-else class="errtips-box">
    <div class="errtips-content">
      {{ errMsg }}
    </div>
  </div>
</template>

<script>
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { Autoplay, Pagination, Navigation } from 'swiper/modules';
  import 'swiper/css';
  import 'swiper/css/pagination';
  import 'swiper/css/navigation';
  // import '@/assets/css/swiper.css';
  import InfoPopup from '@/components/BaseUi/InfoPopup';
  import i18n from '@/i18n';
  import { mapState, mapMutations } from 'vuex';
  // import msgModal from '@/components/BaseUi/MessageModal/src';
  import store from '@/store';
  import PDFModal from './PDFModal.vue';

  const png = require('../../../assets/images/defaultLounge.png');
  export default {
    name: 'ProductDetailsCardsNew',
    components: {
      Swiper,
      SwiperSlide,
      InfoPopup,
      PDFModal,
    },
    props: {
      typeData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        pdfUrl: new Blob(),
        showPdfModal: false,
        data: null,
        timer: null,
        clickFavor: false,
        swiperSlideList: [],
        modules: [Autoplay, Pagination, Navigation],
        facilities: null,
        loungeInfo: null,
        diningInfo: null,
        retailInfo: null,
        benefitInfo: null,
        productData: {
          name: '',
          terminal: '',
          type: '',
          inspection: '',
          region: '',
          imagesList: '',
          businessHours: '',
          businessHoursVO: null,
          location: '',
          boardinggate: '',
          facilities: '',
          overview: '',
          isFavorite: '',
          imgUrl: '',
          publicity: '',
          discount: '',
          countInfo: '',
          airportName: '',
          rule: '',
        },
        clickNeedShow: false,
        showHelpFaq: false,
        isFacilitiesOpen: false,
        errMsg: '',
        currentDateRangeIndex: 0,
        showDateRanger: false,
        pageStayTimeStart: 0,
      };
    },
    mounted() {
      this.getProductInfo();
    },
    beforeUnmount() {
      if (this.diningInfo) {
        this.handleUserDrop();
      }
      this.showPdfModal = false;
    },
    methods: {
      onSlideChangeTransitionEnd(swiper) {
        if (swiper.isEnd) {
          swiper.navigation.nextEl.style.display = 'none';
        } else {
          swiper.navigation.nextEl.style.display = 'block';
        }
        if (swiper.isBeginning) {
          swiper.navigation.prevEl.style.display = 'none';
        } else {
          swiper.navigation.prevEl.style.display = 'block';
        }
      },
      handleUserDrop() {
        if (!this.showPdfModal) {
          const pageStayTimeEnd = new Date().getTime();
          !!window.FS &&
            FS.event('Dining_DetailViewDrop', {
              stayTime: (pageStayTimeEnd - this.pageStayTimeStart) / 1000,
            });
        }
      },
      handleView(params) {
        if (!this.productData.redeemAble) {
          return;
        }
        if (!this.isLogin) {
          // this.$loginModal.show();
          sessionStorage.setItem('afterLoginRouter', this.$route.fullPath);
          this.$router.push('/login');
          return;
        }

        this.goToDiningPDF(params, () => {
          this.showPdfModal = true;
        });

        if (params.setMeal) {
          !!window.FS &&
            FS.event('Dining_SetMealSelect', {
              timestamp: new Date().getTime(),
              location: this.productData.airportCode,
              restaurant: this.productData.name,
              diningID: this.productData.code,
              setMealId: params.setMealId,
              stayTime: (new Date().getTime() - this.pageStayTimeStart) / 1000,
            });
        } else {
          !!window.FS &&
            FS.event('Dining_RedeemOffer', {
              timestamp: new Date().getTime(),
              location: this.productData.airportCode,
              restaurant: this.productData.name,
              diningID: this.productData.code,
              stayTime: (new Date().getTime() - this.pageStayTimeStart) / 1000,
              offerType: params.modeType,
            });
        }
      },
      // Dining打开PDF弹窗
      goToDiningPDF(params, callback) {
        this.$http.lounge
          .diningPDF({
            code: this.typeData.code,
            userId: this.userInfo.userId,
            sessionId: this.userInfo.sessionId,
            lang: this.typeData.lang,
            ...params,
          })
          .then(res => {
            this.pdfUrl = res;
            callback && callback();
          });
      },
      goToNext(type) {
        console.log('message', type);
        if (type === 'walk-in') {
          this.goToMembership();
        }
        if (type === 'pre-book') {
          this.goToPrebook();
        }
      },
      // 去会籍页面
      goToMembership() {
        // 登录时才请求接口
        if (this.isLogin) {
          this.$router.push({
            name: 'Membership',
          });
        } else {
          // this.$loginModal.show();
          sessionStorage.setItem('afterLoginRouter', this.$route.fullPath);
          this.$router.push('/login');
        }
      },
      // 去预定页面
      goToPrebook() {
        // 登录时才请求接口
        if (this.isLogin) {
          // 校验卡状态
          this.$http.lounge
            .cardFreezeStatusCheck({
              userId: this.userInfo.userId,
              sessionId: this.userInfo.sessionId,
              sceneType: 1,
            })
            .then(res => {
              if (res.state === '11') {
                this.$router.push({
                  path: '/lounge/prebook',
                  query: { loungeCode: this.typeData.code },
                });
              } else {
                this.showMessageModal({
                  key: res?.note,
                  i18nNeed: false,
                });
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          sessionStorage.setItem('afterLoginRouter', this.$route.fullPath);
          this.$router.push('/login');
        }
      },
      // 去零售店过滤页
      goToFilter() {
        // https://www.tapd.cn/48507496/prong/stories/view/1148507496001019845?url_cache_key=from_url_iteration_list_90affd9184444071c6f3de945f71f83c&action_entry_type=stories
        // 防止过滤页刷新时丢失数据
        store.commit('setState', {
          state: 'retailAirportCode',
          values: this.typeData.airportCode,
        });
        store.commit('setState', {
          state: 'retailCodes',
          values: this.typeData.code,
        });
        sessionStorage.setItem('retailAirportCode', JSON.stringify(this.typeData.airportCode));
        sessionStorage.setItem('retailCodes', JSON.stringify(this.typeData.code));
        if (this.typeData.code.split(',').length > 1) {
          this.$router.push({
            name: 'RetailDetailsFilter',
            params: { airportCode: this.typeData.airportCode, codes: this.typeData.code },
          });
        } else {
          if (!this.isLogin) {
            sessionStorage.setItem('afterLoginRouter', this.$route.fullPath);
            this.$router.push('/login');
            return;
          }
          this.$http.lounge
            .retailPDF({
              userId: this.userInfo.userId,
              sessionId: this.userInfo.sessionId,
              lang: localStorage.getItem('lang'),
              airportCode: this.retailAirportCode,
              retailCode: this.typeData.code,
            })
            .then(res => {
              this.pdfUrl = res;
              this.showPdfModal = true;
            });
        }
      },
      // 获取休息室、餐厅和零售店详细信息
      getProductInfo() {
        switch (this.typeData.type) {
          case 'lounge': {
            const data = {
              lang: this.$i18n.locale,
              code: this.typeData.code,
              userId: this.userInfo?.userId || undefined,
              device: 'web',
            };
            this.$http.lounge
              .getLoungeDetailsV2(data)
              .then(res => {
                this.loungeInfo = res;
                this.facilities =
                  (res.payload.applyItems &&
                    res.payload.applyItems.split('||').map(item => item.split('#_#'))) ||
                  null;
              })
              .catch(err => {
                console.log(err);
              });
            break;
          }
          case 'dining': {
            const data = {
              code: this.typeData.code,
              lang: this.$i18n.locale,
              userId: this.userInfo?.userId || undefined,
              device: 'web',
              // id: this.typeData.diningId,
            };
            this.$http.lounge
              .getDiningDetails(data)
              .then(res => {
                this.diningInfo = res;
                !!window.FS &&
                  FS.event('Dining_DetailView', {
                    timestamp: new Date().getTime(),
                    location: res?.payload?.airportCode,
                    restaurant: res?.payload?.name,
                    offerType: this.typeData.taglist?.join(',') || '',
                  });
                this.pageStayTimeStart = new Date().getTime();
              })
              .catch(err => {
                console.log(err);
              });
            break;
          }
          case 'retail': {
            const data = {
              airportCode: this.typeData.airportCode,
              lang: this.$i18n.locale,
              userId: this.userInfo?.userId || undefined,
              retailCodes: this.typeData.code,
              device: 'web',
            };
            this.$http.lounge
              .getRetailDetails(data)
              .then(res => {
                this.retailInfo = res;
              })
              .catch(err => {
                console.log(err);
              });
            break;
          }
          default:
            break;
        }
      },
      // 点击收藏按钮
      toggleFavor() {
        // 登录时才请求接口
        if (this.isLogin) {
          this.clickNeedShow = true;
          clearTimeout(this.timer);
          this.timer = setTimeout(() => {
            const { code } = this.productData;
            const data = {
              code,
              type: 1,
              userId: this.userInfo?.userId || undefined,
              lang: this.$i18n.locale,
              sessionId: this.userInfo?.sessionId ?? null,
            };
            // 餐厅type为2
            if (this.diningInfo) {
              data.type = 2;
            }
            if (!this.clickFavor) {
              this.$http.lounge
                .addFavorLounge(data)
                .then(res => {
                  console.log(this.clickFavor);
                  if (res.state !== '00') this.clickFavor = !this.clickFavor;
                })
                .catch(err => {
                  console.log(err);
                });
            } else {
              console.log(this.clickFavor);
              this.$http.lounge
                .cancelFavorLounge(data)
                .then(res => {
                  if (res.state !== '00') this.clickFavor = !this.clickFavor;
                })
                .catch(err => {
                  console.log(err);
                });
            }
            this.timer = null;
          }, 500);
        } else {
          // this.$loginModal.show();
          sessionStorage.setItem('afterLoginRouter', this.$route.fullPath);
          this.$router.push('/login');
        }
      },
      goBack() {
        this.$router.go(-1);
      },
      ...mapMutations(['showMessageModal']),
    },
    computed: {
      favorDesc() {
        if (this.loungeInfo)
          return this.clickFavor ? i18n.t('add-lounge-favor') : i18n.t('remove-lounge-favor');
        else if (this.diningInfo)
          return this.clickFavor ? i18n.t('add-dining-favor') : i18n.t('remove-dining-favor');
      },
      // 对接口返回的facilitiees数据进行转换
      getFacilitiesCategory() {
        return this.facilities.flat().filter((item, index) => {
          return index % 2 === 0;
        });
      },
      getFacilitiesPic() {
        return this.facilities.flat().filter((item, index) => {
          return index % 2 === 1;
        });
      },
      prebookingPrice() {
        return (
          this.productData?.mtpPriceTypes?.filter(item => item.type === '1' || item.type === '2') ||
          []
        );
      },
      walkinPrice() {
        return (
          this.productData?.mtpPriceTypes?.filter(item => item.type === '3' || item.type === '4') ||
          []
        );
      },
      ...mapState(['userInfo', 'isLogin', 'retailAirportCode']),
    },
    watch: {
      // 将休息室数据赋值给productData
      loungeInfo: {
        handler(newVal) {
          if (newVal.state === '11') {
            this.productData = newVal.detail || newVal.payload;
            if (!this.productData.imagesList) {
              this.productData.imagesList = [{ url: png }];
            }
          } else {
            this.errMsg = newVal.note;
            this.productData = null;
          }
        },
      },
      // 将餐厅数据赋值给productData
      diningInfo: {
        handler(newVal) {
          if (newVal.state === '11') {
            this.productData = newVal.payload;
            this.productData.imagesList =
              newVal.payload.productsImageList && newVal.payload.productsImageList.length
                ? newVal.payload.productsImageList
                : [{ url: png }];
            if (newVal.payload.issetmeal === -1) {
              // -1 固定写死
              this.productData.setMealList = [
                {
                  name: this.$t('dining-setmeal'),
                  description: [
                    this.$t('dining-setmeal-options-descrition'),
                    this.$t('dining-setmeal-descrition'),
                  ],
                  groupMap: [
                    {
                      group: null,
                      options: [],
                    },
                  ],
                },
              ];
            } else {
              this.productData.setMealList = newVal.payload.setMealList.map(item => {
                const tempGroupMap = {};
                item.comboDetailList.forEach(item => {
                  if (item.group in tempGroupMap) {
                    tempGroupMap[item.group].push(item.name);
                  } else {
                    tempGroupMap[item.group] = [item.name];
                  }
                });
                item.groupMap = Object.keys(tempGroupMap).map(key => {
                  return {
                    group: key,
                    options: tempGroupMap[key],
                  };
                });
                return { ...item, description: [this.$t('dining-setmeal-options-descrition')] };
              });
            }
          } else {
            this.errMsg = newVal.note;
            this.productData = null;
          }
        },
      },
      // 将零售店数据赋值给productData
      retailInfo: {
        handler(newVal) {
          if (newVal.state === '11') {
            this.productData = newVal.data;
          } else {
            this.errMsg = newVal.note;
            this.productData = null;
          }
        },
      },
      // 初次进入休息室详情页不需要展示favorite信息
      productData: {
        handler(newVal) {
          this.clickFavor = newVal?.isFavorite || newVal?.favorite;
        },
      },
      showPdfModal: {
        handler(newVal) {
          if (!newVal) {
            this.pdfUrl = new Blob();
            this.pageStayTimeStart = new Date().getTime();
          }
        },
      },
    },
  };
</script>
<style lang="scss" scoped>
  @use './newIndex.scss';
</style>
<style lang="scss">
  .swiper-pagination-bullet-custom {
    display: inline-block;
    width: 14px;
    height: 14px;
    // margin-right: 4px;
    background: rgba(22, 48, 73, 0.5);
    border-radius: 100%;
    opacity: 1;

    // &:not(:last-child) {
    //   margin-right: 20px;
    // }
  }

  .swiper-pagination-bullet-active-custom {
    background: #163049;
    opacity: 1;
  }

  @media screen and (max-width: 1024px) {
    .swiper-pagination-bullet-custom {
      display: inline-block;
      width: 10px;
      height: 10px;
      // margin-right: 4px;
      background: rgba(22, 48, 73, 0.5);
      border-radius: 100%;
      opacity: 1;

      // &:not(:last-child) {
      //   margin-right: 16px;
      // }
    }
    .swiper-pagination-bullet-active-custom {
      background: #163049;
      opacity: 1;
    }
  }
</style>
